import { useBrowserStoredValue } from "../../toolympus/hooks/useBrowserStoredValue";
import { useSingleSchema } from "../../toolympus/hooks/useSchema";
import { useSmartList } from "../../toolympus/hooks/useSmartList";

export interface CopDecision {
  _id: number;
  decision: string;
  title: string;
  
  decision_date?: string;
  
  deciding_body?: string;
  agenda_item?: string;
  
  topics?: string[] | null;
  
  document_symbol?: string;
  
  source_url?: string;
  conference_url?: string;


  content?: any;
  description?: any;

  is_published?: boolean;
  published_at?: string;
  moderation_status?: string;
  
  owner_id?: string;
  moderator_id?: string;
  created_at?: string;
  created_by?: string;
}

export const CopDecisionApiPath = "/api/cop-decision";

const CopDecisionTextFilter = (i: CopDecision) => `${i.title} ${i.decision} ${i._id}`;


export const useCopDecisionSchema = () => {
  const { schema } = useSingleSchema(`${CopDecisionApiPath}/uiconfig`);
  return schema;
}

export const useCopDecisionList = () => {
  const schema = useCopDecisionSchema();
  
  const assignedFilter = useBrowserStoredValue("me", undefined, "__iclrcbd_copdecisionlist_my_all");

  const data = useSmartList(CopDecisionApiPath, {
    sorting: { disallowedFields: ["description", "content"] },
    extraParams: {
      assigned: assignedFilter.value === "me" ? "me" : undefined,
    },
    viewDefault: "unpublished",
    lsKeysPrefix: "__iclrcbd_copdecisionlist",
    newRecordDefault: { title: "" },
    schema,
    textFilterFn: CopDecisionTextFilter,
  });

  return {
    ...data,
    assignedFilter,
  }
}

export type CopDecisionListData = ReturnType<typeof useCopDecisionList>;
